import React from 'react';
import { ItemInterfaceProps } from '../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ItemInterface(props: ItemInterfaceProps): JSX.Element {
	return <></>;
}
